import React, { useContext } from 'react'
import AccountMenu from '@/components/Account/Helpers/AccountMenu'
import ProfilePicture from '@/components/Account/Helpers/ProfilePicture'
import { Button } from '@/components/_ui/Button'
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/_ui/Drawer'
import { ScrollArea } from '@/components/_ui/ScrollArea'
import { useGTM } from '@/lib/hooks/google-analytics/useGTM'
import { mixpanelService } from '@/lib/services/mixpanel/initializeMixPanel'
import { MixpanelEvent } from '@/lib/services/mixpanel/mixpanelEvent'
import { NavigationMenuContext } from '@/components/_headers/_shared/navigationMenuContext'

type Props = {
  size?: number
  isMobile?: boolean
}

const AccountDrawer = ({ size = 35, isMobile = false }: Props) => {
  const { isAccountMenuOpen, setIsAccountMenuOpen } = useContext(
    NavigationMenuContext,
  )
  const { gtm } = useGTM()

  return (
    <Drawer
      open={isAccountMenuOpen}
      onOpenChange={(value) => {
        setIsAccountMenuOpen(value)
        if (value) {
          gtm.profileMenuOpened()

          mixpanelService
            .trackEvent(MixpanelEvent.PROFILE_MENU_OPENED, {})
            .catch(() => {})
        }
      }}
    >
      <DrawerTrigger>
        <Button
          className="pointer-events-auto"
          size="icon"
          variant="icon"
          data-test={`account-popover-button${isMobile ? '-mobile' : ''}`}
        >
          <ProfilePicture size={size} />
        </Button>
      </DrawerTrigger>
      <DrawerContent horizontalDirectionWidth={500} className="p-3 py-8 sm:p-8">
        <ScrollArea className="h-full">
          <AccountMenu isAccountPopover />
        </ScrollArea>
      </DrawerContent>
    </Drawer>
  )
}

export default AccountDrawer
